function getTimestampMillis(): number {
  return Date.now();
}

function generateRandom(min: number, max: number): number {
  return Math.floor(Math.random() * (max - min + 1)) + min;
}

function getGtmUniqueEventId(): string {
  const gtmId = (window as any).dataLayer?.find((e: any) => e['gtm.uniqueEventId'])?.['gtm.uniqueEventId'] ?? 0;
  return gtmId >= 0 ? String(gtmId) : '00';
}

function getBrowserId(): string {
  let gtmBrowserId = (window as any).gtmBrowserId;

  if (!gtmBrowserId) {
    gtmBrowserId = `${getTimestampMillis()}${generateRandom(100000, 999999)}`;
    (window as any).gtmBrowserId = gtmBrowserId;
  }

  return gtmBrowserId;
}

function getPageLoadId(): string {
  let gtmPageLoadId = (window as any).gtmPageLoadId;

  if (!gtmPageLoadId) {
    gtmPageLoadId = `${getTimestampMillis()}${generateRandom(100000, 999999)}`;
    (window as any).gtmPageLoadId = gtmPageLoadId;
  }

  return gtmPageLoadId;
}

export function getUniqueEventId(): string {
  return `${getBrowserId()}_${getPageLoadId()}_${getGtmUniqueEventId()}`;
}
